module.exports = __webpack_public_path__ + "img/crosshair.1918374b.svg";